import { Injectable, computed, inject, signal } from "@angular/core";
import { UtilityService } from '@eforall/common';
import { DbDomainData } from "@interfaces";
import { FuncService } from "../func/func.service.gen";
import { domainDataEquality } from "./domain-data-equality";

export interface DomainData {
}

const EMPTY_DOMAIN_DATA: DbDomainData = {
	asOfUtc: 0
}

@Injectable({ providedIn: 'root' })
export class DomainDataService {

	private readonly func = inject(FuncService);
	private readonly util = inject(UtilityService);

	private readonly _dbData = signal<DbDomainData>(EMPTY_DOMAIN_DATA, { equal: domainDataEquality });
	public readonly data = computed(() => {
		const db = this._dbData();

		const data: DomainData = {
		};

		return {
			...data,
		};

	});


	// public async loadDomainData(): Promise<void> {
	// 	this._dbData.set(await this.func.getDomainData());
	// }


	// public async clearDomainData(): Promise<void> {
	// 	this._dbData.set(EMPTY_DOMAIN_DATA);
	// }

}